

export const needToLoadElements = (target, delta) => {

    const isWindow = target === window || target === document;

    const scrollTop = isWindow
        ? (window.scrollY || document.documentElement.scrollTop || 0)
        : target.scrollTop;

    const clientHeight = isWindow
        ? window.innerHeight
        : target.clientHeight;

    const scrollHeight = isWindow
        ? (document.documentElement.scrollHeight || document.body.scrollHeight || 0)
        : target.scrollHeight;

    return (clientHeight + scrollTop) >= (scrollHeight - delta);
}